import React from "react";
import FeedbackContainer from "../Shared/FeedbackContainer";

export default function QATeamLeaderFeedbackContainer() {
    return (
        <FeedbackContainer view='QA Team Leader' />
    );
}